<template>
  <div>
    <SectionTitle
      :has-line="true"
      content="Información de Fortalezas y Necesidades"
    />

    <div class="container-fluid my-2 pt-3 container-color">
      <div class="row">
        <div class="col-12">
          <CustomDropDown
            v-if="showNecessitiesCatalogue"
            id="sn-dd"
            v-model="selectedGrade"
            :options="gradeOptions"
            label="Grado:"
            fieldkey="id"
            fieldname="name"
            placeholder="Seleccione el Grado"
            class="mb-4 w-25 bold-label"
            :disabled="ReadOnly"
          />
          <MultiSelectionPicker
            v-if="!ReadOnly"
            maxlength="1500"
            :isbgwhite="true"
            :enable-bg-alternate="true"
            :all-items="availableNecessities"
            :selected-items="tempCurrentSelection"
            item-type-name="Fortaleza o Necesidad"
            :allow-item-list-editing="
              selectedGrade?.id && hasSkillEdition && !ReadOnly
            "
            :modify-removes-item="true"
            :column-count="1"
            :disabled="ReadOnly"
            @itemDeleted="deleteNecessity"
            @itemAdded="addNewNecessity"
            @itemModified="editNecessity"
          />
        </div>
      </div>

      <div v-if="!ReadOnly" class="row mt-3">
        <div class="col-12">
          <Error
            is-alert-mode
            message="Puede seleccionar una(1) o más necesidades. Selección múltiple."
          />
        </div>
      </div>

      <div v-if="!ReadOnly && topErrorMessage" class="row mt-3">
        <div class="col-12">
          <Error :message="topErrorMessage" />
        </div>
      </div>

      <div>
        <div class="m-3">
          <span>Destreza(s) Seleccionada(s):</span>
          <br />
          <b class="b-font"
            >Complete toda la información solicitada a continuación.</b
          >
          <br />
        </div>
        <div class="ml-3 row" v-for="(item, index) in wrappedSelection">
          <div class="custom-col-md-9  mt-4">
            <span>{{ item.name }}</span>
          </div>
          <div class="custom-col-md-2">
            <div class="d-flex align-items-center">
              <div
                class="d-inline-flex"
                :key="item.id"
              >
                <div
                  class="col-4 centered-col container-selector"
                  :class="{ 'strength-selected': item.isStrength === true, 'is-invalid': item.isStrength == null && isSubmitted }"
                >
                  <div class="custom-control custom-radio check-container mt-4 ">
                    <input
                      :id="`s${item.id}`"
                      type="radio"
                      class="custom-control-input custom-check"
                      :name="`radSatisfyAt${item.id}`"
                      :value="true"
                      @click="savedSelectionTosend($event, item, index)"
                      v-model="item.isStrength"
                      :disabled="item.disabled"
                    />
                    <label
                      :for="`s${item.id}`"
                      class="custom-control-label fw-normal"
                    />
                  </div>
                  <div class="custom-content-strength mt-3">
                    Fortaleza
                  </div>
                </div>
                <div
                  class="col-4 centered-col container-selector"
                  :class="{ 'necessities-selected': item.isStrength === false, 'is-invalid': item.isStrength == null && isSubmitted }"
                >
                  <div class="custom-control custom-radio check-container mt-4 ">
                    <input
                      :id="`n${item.id}`"
                      type="radio"
                      class="custom-control-input"
                      :name="`radSatisfyAt${item.id}`"
                      :value="false"
                      @click="savedSelectionTosend($event, item, index)"
                      v-model="item.isStrength"
                      :disabled="item.disabled"
                    />
                    <label
                      :for="`n${item.id}`"
                      class="custom-control-label fw-normal"
                    />
                  </div>
                  <div class="custom-content-need mt-3">
                    Necesidad
                  </div>
                </div>
                <AcademicProgressLevelPicker
                  v-if="isGoalLevelsEnabled"
                  class="col-4 align-items-center justify-content-end"
                  :class="{ 'is-invalid': isGoalLevelsEnabled && item.levelId == null && isSubmitted }"
                  :value="item.levelId"
                  :levels="academicProgressLevels"
                  :disabled="item.disabled"
                  @input="setLevel(index, $event)"
                />
              </div>
            </div>
            <br />
            <Error
              v-if="isSubmitted && (item.isStrength == null || isGoalLevelsEnabled && item.levelId == null)"
              :class="{ 'container-err': !isGoalLevelsEnabled, 'container-err-xl': isGoalLevelsEnabled }"
              class="mt-1"
              :message="`${isGoalLevelsEnabled && item.levelId == null ? 'Todos los campos son requeridos para continuar.' : 'Es requerido que seleccione una opción.'}`"
            />
          </div>
          <div class="custom-col-md-1 centered-col mt-4">
            <span
              v-if="!item.disabled"
              class="error-val"
              @click="removeSelection(item)"
            >
              <i
                class="fa fa-times-circle pt-2 pb-2 pr-2 pl-2 custom-icon-x"
                aria-hidden="true"
              />
            </span>
          </div>
          <hr class="hr-custom" />
          <div class="col-12">
            <div class="custom-hr" />
            <br />
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="!ReadOnly"
      class="mt-3 d-flex justify-content-end align-items-center"
    >
      <ActionButton i="fas fa-save" variant="success m-2" @click="save">
        Guardar
      </ActionButton>
    </div>
  </div>
</template>

<script>
import MultiSelectionPicker from "@/components/common/MultiSelectionPicker";
import CustomChipsGroup from "@/components/common/CustomChipsGroup";
import alert from "@/mixin/alert.mixin";
import ActionButton from "@/components/common/ActionButton";
import Error from "@/components/common/Error";
import CustomDropDown from "custom-drop-down";
import CustomRadio from "custom-radio";
import PeiApi from "./service";
import peiAcademicProgressCalendar from "@/services/pei/peiAcademicProgressCalendar";

import { SectionTitle, AcademicProgressLevelPicker } from "@/components/pei/shared";
import { createNamespacedHelpers } from "vuex";

import { modulesName } from "@/modules";
const { mapState, mapGetters, mapActions } = createNamespacedHelpers(
  modulesName.programServiceModuleName
);

export default {
  name: "StrengthNecessitiesSelection",
  mixins: [alert],
  props: {
    programServiceAreaId: {
      default: 0
    },
    areaId: {
      default: 0
    },
    selectedPeiId: {
      default: 0
    },
    pei: {
      type: Object,
      default: () => {}
    },
    hasError: {
      type: Boolean,
      default: false
    },
    hasLevelError: {
      type: Boolean,
      default: false
    },
    ReadOnly: {
      type: Boolean,
      default: false
    },
    isGoalLevelsEnabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    MultiSelectionPicker,
    CustomDropDown,
    CustomChipsGroup,
    ActionButton,
    CustomRadio,
    SectionTitle,
    AcademicProgressLevelPicker,
    Error
  },
  data() {
    return {
      isSubmitted: false,
      currentSelection: [],
      //Is required because MultiSelectionPicker work directly on the prop
      tempCurrentSelection: [],
      deletedNecessities: [],
      selectedGrade: null,
      availableNecessities: [],
      academicProgressLevels: [],
      idCounter: 0
    };
  },
  computed: {
    ...mapState(["createdGoals", "selectedStrengthsNecessities"]),
    ...mapGetters([
      "showNecessitiesCatalogue",
      "hasSkillEdition",
      "skillOptions",
      "gradeOptions",
      "resource",
      "defaultGrade",
      "isDiscipline"
    ]),
    hasInnerError() {
      const hasNecessity = this.wrappedSelection.some(
        x => x.isStrength === false
      );
      const hasStrength = this.wrappedSelection.some(
        x => x.isStrength === true
      );

      return !hasNecessity && !hasStrength;
    },
    wrappedSelection() {
      return this.currentSelection.map(x => ({
        ...x,
        disabled: x.disabled || this.ReadOnly,
        name: this.isDiscipline ? `${x.name} (${x.grade ?? x.value})` : x.name
      }));
    },
    topErrorMessage() {
      const messages = [];

      if (this.hasError || (this.isSubmitted && this.hasInnerError)) {
        messages.push("Debe seleccionar al menos una fortaleza o una necesidad.");
      }

      if (this.isGoalLevelsEnabled && this.hasLevelError) {
        messages.push("Debe documentar el nivel (L) de cada destreza seleccionada.");
      }

      return messages.join("<br>");
    }
  },
  methods: {
    ...mapActions(["fetchGoalsTabInfo", "fetchStrengthNecessityTabInfo"]),
    async deleteNecessity(item) {
      let alertResponse = await this.ShowCancelModal(
        "Atención",
        `¿Esta seguro que desea eliminar la necesidad ${item.name}"?`,
        "Aceptar",
        "Cancelar"
      );

      if (!alertResponse) return;

      let removedItemIndex = this.availableNecessities.findIndex(
        e => e.id === item.id
      );
      this.availableNecessities.splice(removedItemIndex, 1);
      this.deletedNecessities.push(item);
    },
    addNewNecessity(itemText) {
      this.availableNecessities.push({
        id: (this.idCounter += -1),
        name: itemText,
        value: this.selectedGrade?.id?.toString(),
        grade: this.selectedGrade?.name
      });
    },
    editNecessity(item, index) {
      if (item.id > 0) {
        item.isDirty = true;
        (item.value = this.selectedGrade?.id?.toString()),
          (item.grade = this.selectedGrade?.name);
      }

      this.availableNecessities.splice(index, 0, item);
    },
    removeSelection(item) {
      if (this.ReadOnly) return;
      let editedItemIndex = this.currentSelection.findIndex(
        e => e.id === item.id
      );
      this.currentSelection.splice(editedItemIndex, 1);
    },
    savedSelectionTosend(value, item, index) {
      if (this.ReadOnly) return;
      const exists = this.currentSelection.some(
        existingItem => existingItem.id === item.id
      );
      if (!exists) return;

      this.currentSelection[index].isStrength = value.target.value == "true";
    },
    setLevel(index, levelId) {
      if (this.ReadOnly) return;
      this.currentSelection[index].levelId = levelId;
    },
    async save() {
      let isValid = true;
      this.isSubmitted = true;

      if (this.hasInnerError) return !isValid;

      const gradeId = this.showNecessitiesCatalogue
        ? this.selectedGrade?.id
        : null;
      const existsNull = this.currentSelection.some(
        existingItem =>
          !existingItem.hasOwnProperty("isStrength") ||
          existingItem.isStrength === null
      );

      if (existsNull) return !isValid;

      const existsNullLevel =
        this.isGoalLevelsEnabled &&
        this.currentSelection.some(
          existingItem =>
            !existingItem.hasOwnProperty("levelId") ||
            existingItem.levelId === null
        );

      if (existsNullLevel) return !isValid;

      let dto = {
        programServiceAreaId: parseInt(this.programServiceAreaId, 10),
        areaId: parseInt(this.areaId, 10),
        peiId: this.selectedPeiId.toString(),
        gradeId: gradeId,
        selectedStrengthNecessities: this.currentSelection,
        availableNecessities: this.availableNecessities,
        deletedStrengthNecessities: this.deletedNecessities
      };

      try {
        await PeiApi.SaveSkillsInfo(dto);
        this.ShowToast(
          this.resource("R03200110"),
          this.resource("R03200109"),
          "success"
        );

        if (!this.hasInnerError) {
          this.isSubmitted = false;
        }

        this.deletedNecessities = [];
        this.$emit('pending-changes', false);

        await this.fetchGoalsTabInfo();
        await this.fetchStrengthNecessityTabInfo(this.selectedGrade?.id);

        return isValid;
      } catch (err) {
        this.ShowToast(err, this.resource("R03200108"), "error");
        return !isValid;
      }
    }
  },
  watch: {
    selectedGrade: {
      deep: true,
      handler(newValue) {
        this.fetchStrengthNecessityTabInfo(newValue?.id);
      }
    },
    skillOptions: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.availableNecessities = [...newValue];
      }
    },
    selectedStrengthsNecessities: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.tempCurrentSelection = [...newValue];
      }
    },
    tempCurrentSelection: {
      deep: true,
      immediate: true,
      handler(newValue) {
        const skillNames = this.createdGoals
          .map(x => x.strenghtsAndNecessities.map(y => y.name.trim()))
          .flat();

        this.currentSelection = newValue.map(x => ({
          ...x,
          disabled: skillNames.includes(x.name.trim()),//Si esta asociada a un objetivo
          isStrength: x.hasOwnProperty("isStrength") ? x.isStrength : null,
          levelId: x.hasOwnProperty("levelId") ? x.levelId : null
        }));
      }
    },
    isGoalLevelsEnabled: {
      immediate: true,
      async handler(newValue) {
        if (!newValue || this.academicProgressLevels.length) return;

        const { data } = await peiAcademicProgressCalendar.getAcademicProgressLevels();
        this.academicProgressLevels = data;
      }
    },
    hasError: {
      immediate: true,
      handler(newValue) {
        if (newValue) this.isSubmitted = true;
      }
    },
    hasLevelError: {
      immediate: true,
      handler(newValue) {
        if (newValue) this.isSubmitted = true;
      }
    },
    defaultGrade: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (!newValue?.id) return;

        this.selectedGrade = { ...newValue };
      }
    },
    currentSelection: {
      deep: true,
      immediate: false,
      handler(newValue, _) {
        const temp = JSON.parse(JSON.stringify(newValue));
        temp.forEach(skill => delete skill.disabled);
        
        if (JSON.stringify(this.selectedStrengthsNecessities) != JSON.stringify(temp)) {
          this.$emit('pending-changes', true);
        }
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables/_colors.scss";
.actions {
  display: flex;
  justify-content: flex-end;
}
::v-deep .bold-label > .data-name {
  font-weight: 700;
  color: map-get($colors, "black") !important;
}
.container-color {
  background-color: #f5f5f5;
}
.b-font {
  font-size: 17px;
}
.container-selector {
  background-color: white;
  width: 150px;
  border-radius: 5px;
  border: 1px solid transparent;
}
.is-invalid {
  border-color: #ff5b5c;
}
.check-container {
  margin-top: 21px;
}
.centered-col {
  text-align: center;
  padding: 0px;
}
.custom-content-strength {
  width: 100%;
  background-color: #a3e5b3;
}
.custom-content-need {
  width: 100%;
  background-color: #fcc9c8;
}
.custom-hr {
  background-color: #dae4e0;
  height: 1.5px;
  weight: 98%;
}
.custom-icon-x {
  color: #c5525d;
  font-size: 24px;
}

.custom-col-md-9 {
  width: 62%;
}
.custom-col-md-2 {
  width: 28%;
}
.custom-col-md-1 {
  width: 10%;
}

@media (max-width: 1407px) {
  .custom-col-md-9 {
    width: 62%;
  }
  .custom-col-md-2 {
    width: 33%;
  }
  .custom-col-md-1 {
    width: 5%;
  }
}

@media (max-width: 1284px) {
  .custom-col-md-9 {
    width: 45%;
  }
  .custom-col-md-2 {
    width: 35%;
  }
  .custom-col-md-1 {
    width: 20%;
  }
}

@media (max-width: 991px) {
  .custom-col-md-9 {
    width: 32%;
  }
  .custom-col-md-2 {
    width: 48%;
  }
  .custom-col-md-1 {
    width: 20%;
  }
}

@media (max-width: 800px) {
  .custom-col-md-9 {
    width: 28%;
  }
  .custom-col-md-2 {
    width: 52%;
  }
  .custom-col-md-1 {
    width: 20%;
  }
}

.container-err {
  width: 260px;
}
.container-err-xl {
  width: 420px;
}
.strength-selected {
  background: #d7fce9 0% 0% no-repeat padding-box;
  border: 1px solid #a3e5b3;
  border-radius: 4px 0px 0px 0px;
  opacity: 1;
}
.necessities-selected {
  background: #ffebeb 0% 0% no-repeat padding-box;
  border: 1px solid #fcc9c8;
  border-radius: 0px 4px 0px 0px;
  opacity: 1;
}
.hr-custom {
  border: 1px solid #f5f5f5;
}
.strength-selected
  .custom-control-input:checked
  + .custom-control-label::before {
  background-color: #a3e5b3;
  border-color: #a3e5b3;
}
.necessities-selected
  .custom-control-input:checked
  + .custom-control-label::before {
  background-color: #fcc9c8;
  border-color: #fcc9c8;
}
</style>
